import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetLessonPlans, ILessonPlanReq } from '../models/semesterLessonPlan.model';

const uri = '/mgmt/semester-lesson-plan';

export const getLessonPlans = (semesterCourseCode: number, timeTableSeq: number): AxiosPromise<IGetLessonPlans> => {
  return axios.get(`${uri}/${semesterCourseCode}/${timeTableSeq}`);
};

export const createLessonPlans = (semesterCourseCode: number, data: ILessonPlanReq[]): AxiosPromise => {
  return axios.post(`${uri}/${semesterCourseCode}`, data);
};

export const updateLessonPlans = (data: ILessonPlanReq[]): AxiosPromise => {
  return axios.put(uri, data);
};
